unit Essentials.Web.Attributes.Form;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  XData.Web.Client,
  WEBLib.DB,
  Vcl.Controls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls,
  Essentials.Web.Shared, WebForm.Core,
  Generics.Collections,
  Essentials.Web.Attributes.Validation, WEBLib.Lists, Grid.Plugins;

type
  TEssentialsAttributesForm = class(TCoreWebForm)
    EssentialsAttributesTable: TDBTableControl;
    AttributesSource: TDataSource;
    AttributesDataset: TXDataWebDataSet;
    AttributesDatasetId: TIntegerField;
    AttributesDatasetDateAdded: TDateTimeField;
    AttributesDatasetAddedBy: TIntegerField;
    AttributesDatasetLastUpdatedBy: TIntegerField;
    AttributesDatasetLastUpdated: TDateTimeField;
    AttributesDatasetEntityClassName: TStringField;
    AttributesDatasetEntityId: TIntegerField;
    AttributesAddButton: TButton;
    AttributesDatasetDataValue: TStringField;
    AttributesDatasetAttributeId: TIntegerField;
    AttributesDefinitionSource: TDataSource;
    AttributesDefinitionDataset: TXDataWebDataSet;
    AttributesDefinitionDatasetId: TIntegerField;
    AttributesDefinitionDatasetDateAdded: TDateTimeField;
    AttributesDefinitionDatasetAddedBy: TIntegerField;
    AttributesDefinitionDatasetLastUpdatedBy: TIntegerField;
    AttributesDefinitionDatasetLastUpdated: TDateTimeField;
    AttributesDefinitionDatasetEntityName: TStringField;
    AttributesDefinitionDatasetValueKind: TStringField;
    AttributesDatasetAttributeName: TStringField;
    AttributesDefinitionDatasetName: TStringField;
    AttributesDefinitionDatasetMultiValue: TBooleanField;
    AttributesDefinitionDatasetIsActive: TBooleanField;
    DeleteConfirmationMsg: TMessageDlg;
    cbPageSize: TComboBox;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure AttributesSourceStateChange(Sender: TObject);
    procedure AttributesDatasetNewRecord(DataSet: TDataSet);
    procedure EssentialsAttributesTableGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure AttributesAddButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
  private
    { Private declarations }
    FEntityClassName: string;
    FEntityId: Integer;
    FAttributeValidator: TAttributesValidator;
    FGridPlugin: TGridPlugin;
    procedure SetEntityId(const Value: Integer);
    procedure SetEntityName(const Value: string);
    procedure AddRowActions(const ARecordId: integer; AParentElement: TJSHTMLElement);
    [Async]
    procedure LoadAttributes; async;
    [Async]
    procedure LoadAttributeNames; async;
    [Async]
    procedure Load; async;
    [Async]
    procedure DeleteRecord(ARecordId: integer); async;
    [Async]
    procedure EditRecord(ARecordId: integer); async;
    [Async]
    procedure SaveAttribute; async;
  public
    { Public declarations }
    destructor Destroy; override;
    property EntityClassName: string read FEntityClassName write SetEntityName;
    property EntityId: Integer read FEntityId write SetEntityId;
  protected procedure LoadDFMValues; override; end;

var
  EssentialsAttributesForm: TEssentialsAttributesForm;

implementation

uses
  //  ConnectionModule,
  XData.Dataset.Utils,
  SMX.Web.Layout.Utils,
  WebLib.WebCtrls,
  Essentials.Web.Attributes.EditAttributeValueForm,
  SMX.Webcore.Types;

{$R *.dfm}

{ TEssentialsAttributesForm }

procedure TEssentialsAttributesForm.AddRowActions(const ARecordId: integer;
  AParentElement: TJSHTMLElement);

  procedure EditClick(Sender: TObject);
  begin
    EditRecord(ARecordId);
  end;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteRecord(ARecordId);
  end;

var
  Span: THTMLSpan;
begin
  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'View');
  Span.OnClick := @EditClick;

  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash', 'Delete');
  Span.OnClick := @DeleteClick;
end;

procedure TEssentialsAttributesForm.AttributesAddButtonClick(Sender: TObject);
begin
  inherited;
  EditRecord(0);
end;

procedure TEssentialsAttributesForm.AttributesDatasetNewRecord(
  DataSet: TDataSet);
begin
  inherited;
  AttributesDatasetDateAdded.Value := Now;
  AttributesDatasetLastUpdated.Value := AttributesDatasetDateAdded.Value;
  AttributesDatasetEntityClassName.Value := FEntityClassName;
  AttributesDatasetEntityId.Value := FEntityId;
end;

procedure TEssentialsAttributesForm.AttributesSourceStateChange(
  Sender: TObject);
begin
  inherited;
  AttributesAddButton.Enabled := FEntityId > 0;
end;

procedure TEssentialsAttributesForm.cbPageSizeChange(Sender: TObject);
begin
  inherited;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TEssentialsAttributesForm.DeleteRecord(ARecordId: integer); {$IFDEF PAS2JS}async;{$ENDIF}
  function GetDeleteMsg: string;
  var
    value, attributeName: string;
  begin
    value := AttributesDataset.FieldByName('DataValue').AsString;
    attributeName := AttributesDataset.FieldByName('AttributeName').AsString;;
    DeleteConfirmationMsg.Title := 'Delete ' + attributeName;
    if value = '' then
      value := attributeName;

    Result := Format(DELETE_CONFIRMATION_SCHEMA, [QuotedStr(value)]);
  end;
var {DeleteRecord}
  foundRecord: Boolean;
  EntityData: TJSObject;
begin
  foundRecord := AttributesDataset.Locate('Id', ARecordId, []);
  if foundRecord and (Await(TModalResult, DeleteConfirmationMsg.ShowDialog(GetDeleteMsg, mtConfirmation, [mbYes, mbNo])) = mrYes) then
  begin
    AttributesDataset.Locate('Id', ARecordId, []);
    EntityData := TJSObject(AttributesDataset.CurrentData);
    Await(TXDataClientResponse, EssentialsManager.WebClient.DeleteAsync(
      AttributesDataset.EntitySetName, EntityData));

    FGridPlugin.Load;
  end;
end;

destructor TEssentialsAttributesForm.Destroy;
begin
  FAttributeValidator.Free;
  FGridPlugin.Free;
  inherited;
end;

procedure TEssentialsAttributesForm.EssentialsAttributesTableGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: integer;
begin
  if ARow = 0 then
    Exit;

  if EssentialsAttributesTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := AttributesDataset.FieldByName('Id').AsInteger;
    if RecordId > 0 then
      AddRowActions(RecordId, AElement.Element)
    else
      AElement.Element.textContent := 'Loading...';
  end;
end;

procedure TEssentialsAttributesForm.Load; {$IFDEF PAS2JS}async;{$ENDIF}
begin
  Await(LoadAttributeNames);
  Await(LoadAttributes);
  FGridPlugin.SetPreparedFilter('EntityName eq ' + FEntityClassName.QuotedString + ' and EntityId eq ' + FEntityId.ToString);
end;

procedure TEssentialsAttributesForm.LoadAttributeNames; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lQuery: string;
begin
  if AttributesDefinitionDataset.Active or FEntityClassName.IsEmpty then
    Exit;

  AttributesDefinitionDataset.Close;
  lQuery := '$filter=EntityName eq ' + FEntityClassName.QuotedString;
  lQuery := lQuery + '&$orderby=Name asc';
  AttributesDefinitionDataset.QueryString := lQuery;
  Await(AttributesDefinitionDataset.LoadAsync);
  FAttributeValidator.RebuildAttributeDefinitions(AttributesDefinitionDataset);
end;

procedure TEssentialsAttributesForm.LoadAttributes; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lQuery: string;
begin
  if (FEntityId = 0) or FEntityClassName.IsEmpty then
    Exit;

  //Don't bother if we have already opened
  if AttributesDataset.Active then
    Exit;

  lQuery := '$filter=EntityName eq ' + FEntityClassName.QuotedString + ' and EntityId eq ' + FEntityId.ToString;
  AttributesDataset.QueryString := lQuery;
  Await(AttributesDataset.LoadAsync);
  FAttributeValidator.RebuildAttributes(AttributesDataset);
end;

procedure TEssentialsAttributesForm.SetEntityId(const Value: Integer);
begin
  if (FEntityId = Value) then
    Exit;

  if (FEntityId > 0) and (FEntityId <> Value) and AttributesDataset.Active then
    AttributesDataset.Close;

  FEntityId := Value;
  Load;
end;

procedure TEssentialsAttributesForm.SetEntityName(const Value: string);
begin
  if FEntityClassName = Value then
    Exit;

  FEntityClassName := Value;
  Load;
end;

procedure TEssentialsAttributesForm.SaveAttribute; {$IFDEF PAS2JS}async;{$ENDIF}
var
  Info: TResolveResults;
  myId: Integer;
  lIdx: Integer;
  lResolveInfo: TResolveInfo;
begin
  if TXDataDSUtils.CheckIsModified(AttributesDataset) then
  begin
    Info := Await(AttributesDataset.ApplyUpdatesAsync);
//    TXDataDSUtils.UpdateAllIds(AttributesDataset, Info, 'Id');

    for lIdx := 0 to Length(Info.Records) - 1 do
    begin
      lResolveInfo := Info.Records[lIdx];
      if (lResolveInfo.Status = usInserted) or (lResolveInfo.Status = usModified) then
      begin
        if lResolveInfo.Status = usInserted then
          TXDataDSUtils.UpdateId(AttributesDataset, Info, 'Id', lIdx);
      end;
    end;

    FAttributeValidator.RebuildAttributes(AttributesDataset);
    FGridPlugin.Load;
  end;
end;

procedure TEssentialsAttributesForm.EditRecord(ARecordId: integer); {$IFDEF PAS2JS}async;{$ENDIF}
var
  AForm: TEditAttributeValue;
begin
  AForm := TEditAttributeValue.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    Await(TEditAttributeValue, AForm.Load());
    AForm.SetDataSources(AttributesDataset, AttributesDefinitionSource);
    AForm.Validator := FAttributeValidator;

    if ARecordId = 0 then
    begin
      AttributesDefinitionDataset.Filter := 'IsActive = True';
      AttributesDefinitionDataset.Filtered := True;
      AForm.EditMode := Add;
      AttributesDataset.Insert;
    end
    else
    begin
      AForm.EditMode := None;
      AttributesDataset.Locate('Id', ARecordId, []);
    end;

    if Await(TModalResult, AForm.Execute) = mrOK then
      Await(SaveAttribute);
  finally
    AttributesDefinitionDataset.Filtered := False;
    FreeAndNil(AForm);
  end;
end;


procedure TEssentialsAttributesForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  FAttributeValidator := TAttributesValidator.Create;
  AttributesDataset.Connection := EssentialsManager.WebClient.Connection;
  AttributesDefinitionDataset.Connection := EssentialsManager.WebClient.Connection;
  FGridPlugin := TGridPlugin.Create(EssentialsAttributesTable, AttributesDataset, lcPaginator, lbPaginationInfo,
      TSortPair.Create(1, sdAsc));

  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
end;

procedure TEssentialsAttributesForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('attributes.form.PageInfo');
  EssentialsAttributesTable := TDBTableControl.Create('essentials.attributes.table');
  AttributesAddButton := TButton.Create('essentials.attributes.add.button');
  DeleteConfirmationMsg := TMessageDlg.Create('DeleteConfirmationMsg');
  cbPageSize := TComboBox.Create('attributes.form.PageSizeSelect');
  lcPaginator := TListControl.Create('attributes.form.Pagination');
  AttributesSource := TDataSource.Create(Self);
  AttributesDataset := TXDataWebDataSet.Create(Self);
  AttributesDatasetId := TIntegerField.Create(Self);
  AttributesDatasetDateAdded := TDateTimeField.Create(Self);
  AttributesDatasetAddedBy := TIntegerField.Create(Self);
  AttributesDatasetLastUpdatedBy := TIntegerField.Create(Self);
  AttributesDatasetLastUpdated := TDateTimeField.Create(Self);
  AttributesDatasetEntityClassName := TStringField.Create(Self);
  AttributesDatasetEntityId := TIntegerField.Create(Self);
  AttributesDatasetDataValue := TStringField.Create(Self);
  AttributesDatasetAttributeId := TIntegerField.Create(Self);
  AttributesDatasetAttributeName := TStringField.Create(Self);
  AttributesDefinitionSource := TDataSource.Create(Self);
  AttributesDefinitionDataset := TXDataWebDataSet.Create(Self);
  AttributesDefinitionDatasetId := TIntegerField.Create(Self);
  AttributesDefinitionDatasetDateAdded := TDateTimeField.Create(Self);
  AttributesDefinitionDatasetAddedBy := TIntegerField.Create(Self);
  AttributesDefinitionDatasetLastUpdatedBy := TIntegerField.Create(Self);
  AttributesDefinitionDatasetLastUpdated := TDateTimeField.Create(Self);
  AttributesDefinitionDatasetEntityName := TStringField.Create(Self);
  AttributesDefinitionDatasetName := TStringField.Create(Self);
  AttributesDefinitionDatasetValueKind := TStringField.Create(Self);
  AttributesDefinitionDatasetMultiValue := TBooleanField.Create(Self);
  AttributesDefinitionDatasetIsActive := TBooleanField.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  EssentialsAttributesTable.BeforeLoadDFMValues;
  AttributesAddButton.BeforeLoadDFMValues;
  DeleteConfirmationMsg.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  AttributesSource.BeforeLoadDFMValues;
  AttributesDataset.BeforeLoadDFMValues;
  AttributesDatasetId.BeforeLoadDFMValues;
  AttributesDatasetDateAdded.BeforeLoadDFMValues;
  AttributesDatasetAddedBy.BeforeLoadDFMValues;
  AttributesDatasetLastUpdatedBy.BeforeLoadDFMValues;
  AttributesDatasetLastUpdated.BeforeLoadDFMValues;
  AttributesDatasetEntityClassName.BeforeLoadDFMValues;
  AttributesDatasetEntityId.BeforeLoadDFMValues;
  AttributesDatasetDataValue.BeforeLoadDFMValues;
  AttributesDatasetAttributeId.BeforeLoadDFMValues;
  AttributesDatasetAttributeName.BeforeLoadDFMValues;
  AttributesDefinitionSource.BeforeLoadDFMValues;
  AttributesDefinitionDataset.BeforeLoadDFMValues;
  AttributesDefinitionDatasetId.BeforeLoadDFMValues;
  AttributesDefinitionDatasetDateAdded.BeforeLoadDFMValues;
  AttributesDefinitionDatasetAddedBy.BeforeLoadDFMValues;
  AttributesDefinitionDatasetLastUpdatedBy.BeforeLoadDFMValues;
  AttributesDefinitionDatasetLastUpdated.BeforeLoadDFMValues;
  AttributesDefinitionDatasetEntityName.BeforeLoadDFMValues;
  AttributesDefinitionDatasetName.BeforeLoadDFMValues;
  AttributesDefinitionDatasetValueKind.BeforeLoadDFMValues;
  AttributesDefinitionDatasetMultiValue.BeforeLoadDFMValues;
  AttributesDefinitionDatasetIsActive.BeforeLoadDFMValues;
  try
    Color := clBtnFace;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 264;
    lbPaginationInfo.Top := 13;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.Color := clBtnFace;
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    EssentialsAttributesTable.SetParentComponent(Self);
    EssentialsAttributesTable.Name := 'EssentialsAttributesTable';
    EssentialsAttributesTable.Left := 96;
    EssentialsAttributesTable.Top := 48;
    EssentialsAttributesTable.Width := 425;
    EssentialsAttributesTable.Height := 257;
    EssentialsAttributesTable.HeightStyle := ssAuto;
    EssentialsAttributesTable.WidthStyle := ssAuto;
    EssentialsAttributesTable.BorderColor := clSilver;
    EssentialsAttributesTable.ElementFont := efCSS;
    EssentialsAttributesTable.ElementHeaderClassName := 'thead-light';
    EssentialsAttributesTable.ElementPosition := epIgnore;
    EssentialsAttributesTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsAttributesTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsAttributesTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsAttributesTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsAttributesTable.Footer.InputElementClassName := 'form-control';
    EssentialsAttributesTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsAttributesTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsAttributesTable.Footer.ListElementClassName := 'pagination';
    EssentialsAttributesTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsAttributesTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsAttributesTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsAttributesTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsAttributesTable.Header.DropDownElementClassName := 'form-control';
    EssentialsAttributesTable.Header.InputElementClassName := 'form-control';
    EssentialsAttributesTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsAttributesTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsAttributesTable.Header.ListElementClassName := 'pagination';
    EssentialsAttributesTable.Header.ListItemElementClassName := 'page-item';
    EssentialsAttributesTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsAttributesTable, Self, 'OnGetCellChildren', 'EssentialsAttributesTableGetCellChildren');
    EssentialsAttributesTable.Columns.Clear;
    with EssentialsAttributesTable.Columns.Add do
    begin
      DataField := 'AttributeName';
      Title := 'Attribute';
    end;
    with EssentialsAttributesTable.Columns.Add do
    begin
      DataField := 'DataValue';
      Title := 'Value';
    end;
    with EssentialsAttributesTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    EssentialsAttributesTable.DataSource := AttributesSource;
    AttributesAddButton.SetParentComponent(Self);
    AttributesAddButton.Name := 'AttributesAddButton';
    AttributesAddButton.Left := 96;
    AttributesAddButton.Top := 335;
    AttributesAddButton.Width := 96;
    AttributesAddButton.Height := 25;
    AttributesAddButton.Caption := 'Add';
    AttributesAddButton.ChildOrder := 7;
    AttributesAddButton.ElementClassName := 'btn btn-light';
    AttributesAddButton.ElementFont := efCSS;
    AttributesAddButton.ElementPosition := epIgnore;
    AttributesAddButton.HeightStyle := ssAuto;
    AttributesAddButton.HeightPercent := 100.000000000000000000;
    AttributesAddButton.WidthStyle := ssAuto;
    AttributesAddButton.WidthPercent := 100.000000000000000000;
    SetEvent(AttributesAddButton, Self, 'OnClick', 'AttributesAddButtonClick');
    DeleteConfirmationMsg.SetParentComponent(Self);
    DeleteConfirmationMsg.Name := 'DeleteConfirmationMsg';
    DeleteConfirmationMsg.Left := 24;
    DeleteConfirmationMsg.Top := 264;
    DeleteConfirmationMsg.Width := 24;
    DeleteConfirmationMsg.Height := 24;
    DeleteConfirmationMsg.ElementClassName := 'PopUpForm';
    DeleteConfirmationMsg.Buttons := [];
    DeleteConfirmationMsg.Opacity := 0.200000000000000000;
    DeleteConfirmationMsg.Title := 'Delete';
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 112;
    cbPageSize.Top := 10;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 232;
    lcPaginator.Top := 335;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    AttributesSource.SetParentComponent(Self);
    AttributesSource.Name := 'AttributesSource';
    AttributesSource.AutoEdit := False;
    AttributesSource.DataSet := AttributesDataset;
    SetEvent(AttributesSource, Self, 'OnStateChange', 'AttributesSourceStateChange');
    AttributesSource.Left := 32;
    AttributesSource.Top := 144;
    AttributesDataset.SetParentComponent(Self);
    AttributesDataset.Name := 'AttributesDataset';
    SetEvent(AttributesDataset, Self, 'OnNewRecord', 'AttributesDatasetNewRecord');
    AttributesDataset.EntitySetName := 'sxeDataAttribute';
    AttributesDataset.Left := 32;
    AttributesDataset.Top := 80;
    AttributesDatasetId.SetParentComponent(AttributesDataset);
    AttributesDatasetId.Name := 'AttributesDatasetId';
    AttributesDatasetId.FieldName := 'Id';
    AttributesDatasetDateAdded.SetParentComponent(AttributesDataset);
    AttributesDatasetDateAdded.Name := 'AttributesDatasetDateAdded';
    AttributesDatasetDateAdded.FieldName := 'DateAdded';
    AttributesDatasetAddedBy.SetParentComponent(AttributesDataset);
    AttributesDatasetAddedBy.Name := 'AttributesDatasetAddedBy';
    AttributesDatasetAddedBy.FieldName := 'AddedBy';
    AttributesDatasetLastUpdatedBy.SetParentComponent(AttributesDataset);
    AttributesDatasetLastUpdatedBy.Name := 'AttributesDatasetLastUpdatedBy';
    AttributesDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    AttributesDatasetLastUpdated.SetParentComponent(AttributesDataset);
    AttributesDatasetLastUpdated.Name := 'AttributesDatasetLastUpdated';
    AttributesDatasetLastUpdated.FieldName := 'LastUpdated';
    AttributesDatasetEntityClassName.SetParentComponent(AttributesDataset);
    AttributesDatasetEntityClassName.Name := 'AttributesDatasetEntityClassName';
    AttributesDatasetEntityClassName.FieldName := 'EntityName';
    AttributesDatasetEntityClassName.Size := 64;
    AttributesDatasetEntityId.SetParentComponent(AttributesDataset);
    AttributesDatasetEntityId.Name := 'AttributesDatasetEntityId';
    AttributesDatasetEntityId.FieldName := 'EntityId';
    AttributesDatasetDataValue.SetParentComponent(AttributesDataset);
    AttributesDatasetDataValue.Name := 'AttributesDatasetDataValue';
    AttributesDatasetDataValue.FieldName := 'DataValue';
    AttributesDatasetAttributeId.SetParentComponent(AttributesDataset);
    AttributesDatasetAttributeId.Name := 'AttributesDatasetAttributeId';
    AttributesDatasetAttributeId.FieldName := 'AttributeId';
    AttributesDatasetAttributeName.SetParentComponent(AttributesDataset);
    AttributesDatasetAttributeName.Name := 'AttributesDatasetAttributeName';
    AttributesDatasetAttributeName.DisplayWidth := 10;
    AttributesDatasetAttributeName.FieldKind := fkLookup;
    AttributesDatasetAttributeName.FieldName := 'AttributeName';
    AttributesDatasetAttributeName.LookupDataSet := AttributesDefinitionDataset;
    AttributesDatasetAttributeName.LookupKeyFields := 'Id';
    AttributesDatasetAttributeName.LookupResultField := 'Name';
    AttributesDatasetAttributeName.KeyFields := 'AttributeId';
    AttributesDatasetAttributeName.Size := 64;
    AttributesDatasetAttributeName.Lookup := True;
    AttributesDefinitionSource.SetParentComponent(Self);
    AttributesDefinitionSource.Name := 'AttributesDefinitionSource';
    AttributesDefinitionSource.DataSet := AttributesDefinitionDataset;
    SetEvent(AttributesDefinitionSource, Self, 'OnStateChange', 'AttributesSourceStateChange');
    AttributesDefinitionSource.Left := 552;
    AttributesDefinitionSource.Top := 272;
    AttributesDefinitionDataset.SetParentComponent(Self);
    AttributesDefinitionDataset.Name := 'AttributesDefinitionDataset';
    AttributesDefinitionDataset.EntitySetName := 'sxeDataAttributeDef';
    AttributesDefinitionDataset.Left := 552;
    AttributesDefinitionDataset.Top := 216;
    AttributesDefinitionDatasetId.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetId.Name := 'AttributesDefinitionDatasetId';
    AttributesDefinitionDatasetId.FieldName := 'Id';
    AttributesDefinitionDatasetDateAdded.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetDateAdded.Name := 'AttributesDefinitionDatasetDateAdded';
    AttributesDefinitionDatasetDateAdded.FieldName := 'DateAdded';
    AttributesDefinitionDatasetAddedBy.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetAddedBy.Name := 'AttributesDefinitionDatasetAddedBy';
    AttributesDefinitionDatasetAddedBy.FieldName := 'AddedBy';
    AttributesDefinitionDatasetLastUpdatedBy.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetLastUpdatedBy.Name := 'AttributesDefinitionDatasetLastUpdatedBy';
    AttributesDefinitionDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    AttributesDefinitionDatasetLastUpdated.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetLastUpdated.Name := 'AttributesDefinitionDatasetLastUpdated';
    AttributesDefinitionDatasetLastUpdated.FieldName := 'LastUpdated';
    AttributesDefinitionDatasetEntityName.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetEntityName.Name := 'AttributesDefinitionDatasetEntityName';
    AttributesDefinitionDatasetEntityName.FieldName := 'EntityName';
    AttributesDefinitionDatasetEntityName.Size := 64;
    AttributesDefinitionDatasetName.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetName.Name := 'AttributesDefinitionDatasetName';
    AttributesDefinitionDatasetName.FieldName := 'Name';
    AttributesDefinitionDatasetName.Size := 64;
    AttributesDefinitionDatasetValueKind.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetValueKind.Name := 'AttributesDefinitionDatasetValueKind';
    AttributesDefinitionDatasetValueKind.DisplayWidth := 64;
    AttributesDefinitionDatasetValueKind.FieldName := 'ValueKind';
    AttributesDefinitionDatasetValueKind.Size := 64;
    AttributesDefinitionDatasetMultiValue.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetMultiValue.Name := 'AttributesDefinitionDatasetMultiValue';
    AttributesDefinitionDatasetMultiValue.FieldName := 'MultiValue';
    AttributesDefinitionDatasetIsActive.SetParentComponent(AttributesDefinitionDataset);
    AttributesDefinitionDatasetIsActive.Name := 'AttributesDefinitionDatasetIsActive';
    AttributesDefinitionDatasetIsActive.FieldName := 'IsActive';
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    EssentialsAttributesTable.AfterLoadDFMValues;
    AttributesAddButton.AfterLoadDFMValues;
    DeleteConfirmationMsg.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    AttributesSource.AfterLoadDFMValues;
    AttributesDataset.AfterLoadDFMValues;
    AttributesDatasetId.AfterLoadDFMValues;
    AttributesDatasetDateAdded.AfterLoadDFMValues;
    AttributesDatasetAddedBy.AfterLoadDFMValues;
    AttributesDatasetLastUpdatedBy.AfterLoadDFMValues;
    AttributesDatasetLastUpdated.AfterLoadDFMValues;
    AttributesDatasetEntityClassName.AfterLoadDFMValues;
    AttributesDatasetEntityId.AfterLoadDFMValues;
    AttributesDatasetDataValue.AfterLoadDFMValues;
    AttributesDatasetAttributeId.AfterLoadDFMValues;
    AttributesDatasetAttributeName.AfterLoadDFMValues;
    AttributesDefinitionSource.AfterLoadDFMValues;
    AttributesDefinitionDataset.AfterLoadDFMValues;
    AttributesDefinitionDatasetId.AfterLoadDFMValues;
    AttributesDefinitionDatasetDateAdded.AfterLoadDFMValues;
    AttributesDefinitionDatasetAddedBy.AfterLoadDFMValues;
    AttributesDefinitionDatasetLastUpdatedBy.AfterLoadDFMValues;
    AttributesDefinitionDatasetLastUpdated.AfterLoadDFMValues;
    AttributesDefinitionDatasetEntityName.AfterLoadDFMValues;
    AttributesDefinitionDatasetName.AfterLoadDFMValues;
    AttributesDefinitionDatasetValueKind.AfterLoadDFMValues;
    AttributesDefinitionDatasetMultiValue.AfterLoadDFMValues;
    AttributesDefinitionDatasetIsActive.AfterLoadDFMValues;
  end;
end;

end.
